"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuContainer = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
function MenuContainer(props) {
    var onItemClick = props.onItemClick, children = props.children, testId = props.testId;
    return (react_1.default.createElement("div", { onClick: onItemClick, role: "menu", tabIndex: 0, onKeyDown: function (event) {
            if (event.key === 'Enter') {
                onItemClick();
            }
        }, "data-testid": testId }, children));
}
exports.MenuContainer = MenuContainer;
//# sourceMappingURL=container.js.map